import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { UserCapability } from 'identity-management';
import { AppRoutes, SIDEBAR_ROUTES, SidebarRoutes } from 'shared-utils';
import { UserService } from 'shared-data-access';
import { CapabilitiesService } from 'capabilities';

export const isAuthorizedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const capabilitiesService = inject(CapabilitiesService);

  if (canAccessByCapability(capabilitiesService, route)) {
    return true;
  }

  const userService = inject(UserService);
  const isFreshLogin: boolean = userService.isFirstRouteAfterLogin();

  const router = inject(Router);

  return isFreshLogin
    ? router.createUrlTree([getFirstPossibleRoute(capabilitiesService) || AppRoutes.NoAccess])
    : router.createUrlTree([AppRoutes.NoAccess], {
        queryParams: {
          from: state.url,
        },
      });
};

function getFirstPossibleRoute(capabilitiesService: CapabilitiesService): SidebarRoutes | undefined {
  return SIDEBAR_ROUTES.find((route: SidebarRoutes) =>
    capabilitiesService.hasSomeCapability(capabilitiesService.getCapabilitiesForRoute(route))
  );
}

function canAccessByCapability(capabilitiesService: CapabilitiesService, route: ActivatedRouteSnapshot): boolean {
  const capabilities: UserCapability[] = route.data['capabilities'] || [];

  return !capabilities.length || capabilitiesService.hasSomeCapability(capabilities);
}
